import styled from "@emotion/styled";

export const Container = styled.div`
  padding-top: 5px;
  .sku {
    font-weight: 300;
    font-size: 85%;
  }
  .gallery {
    display: flex;
    margin-bottom: 20px;
    overflow-y: scroll;
    > span {
      display: flex;
      > div {
        margin-right: 10px;
        border: 1px solid #eee;
        padding: 5px;
        display: flex;

        > div {
          display: flex;
          align-items: center;
        }
      }
    }
    img {
      max-width: 150px;
      max-height: 150px;
      object-fit: cover;
    }
  }
  
  .actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;
